import { normalizeRole } from '../../../utils/assignmentRules';

/**
 * Hook to manage form validation for RaiseQueryForm
 * @param {Object} formData - Form data object
 * @param {Object} currentUser - Current user object
 * @returns {Function} Validation function
 */
export const useRaiseQueryValidation = (formData, currentUser) => {
  const validate = () => {
    const newErrors = {};
    const role = normalizeRole(currentUser?.role);
    const isRegionRequired = role === 'CH' || role === 'MP';
    // Query type is not mandatory - defaults to GENERAL
    if (isRegionRequired && !formData.region) newErrors.region = 'Region is required';
    if (!formData.projectName) newErrors.projectName = 'Project name is required';
    if (!formData.queryDescription)
      newErrors.queryDescription = 'Description is required';
    if (!formData.assigneeId) newErrors.assigneeId = 'Assign To is required';
    if (!formData.statusLabel) newErrors.statusLabel = 'Status is required';
    return newErrors;
  };

  return { validate };
};
